/**
 * SystemAssessmentCard - Displays overall system health assessment
 */

import React from "react";
import {Card, CardBody, Row, Col, Badge} from "reactstrap";
import {SystemAssessment, AssessmentLevel} from "../../types/advancedAnalysis";

interface SystemAssessmentCardProps {
  assessment: SystemAssessment;
}

const getAssessmentColor = (level: AssessmentLevel): string => {
  switch (level) {
    case "excellent":
      return "success";
    case "good":
      return "success";
    case "fair":
      return "warning";
    case "poor":
      return "warning";
    case "critical":
      return "danger";
    default:
      return "secondary";
  }
};

const getAssessmentIcon = (level: AssessmentLevel): string => {
  switch (level) {
    case "excellent":
      return "fa-check-circle";
    case "good":
      return "fa-check";
    case "fair":
      return "fa-exclamation-triangle";
    case "poor":
      return "fa-exclamation-circle";
    case "critical":
      return "fa-times-circle";
    default:
      return "fa-question-circle";
  }
};

const SystemAssessmentCard: React.FC<SystemAssessmentCardProps> = ({assessment}) => {
  const bgColor = getAssessmentColor(assessment.Overall);

  return (
    <Card className="system-assessment-card">
      <CardBody className="p-0">
        <h5 className="card-title px-4 pt-3 mb-3">System Assessment</h5>

        {/* Full-width banner */}
        <div className={`bg-${bgColor} text-center py-3 mb-3`}>
          <div style={{color: "#1e1e1e", fontSize: "1.5rem", fontWeight: "bold"}}>
            <i className={`fa ${getAssessmentIcon(assessment.Overall)} mr-2`}></i>
            {assessment.Overall.toUpperCase()}
          </div>
        </div>

        <div className="px-3 pb-3">
          <p className="text-muted mb-3">{assessment.Summary}</p>

          <Row className="mt-3 assessment-categories">
            <Col xs="6" className="mb-2">
              <div className="d-flex align-items-center category-item">
                <i className="fa fa-desktop mr-2"></i>
                <span>Graphics: {assessment.Graphics}</span>
              </div>
            </Col>
            <Col xs="6" className="mb-2">
              <div className="d-flex align-items-center category-item">
                <i className="fa fa-wifi mr-2"></i>
                <span>Network: {assessment.Network}</span>
              </div>
            </Col>
            <Col xs="6" className="mb-2">
              <div className="d-flex align-items-center category-item">
                <i className="fa fa-heartbeat mr-2"></i>
                <span>Sensors: {assessment.Sensors}</span>
              </div>
            </Col>
            <Col xs="6" className="mb-2">
              <div className="d-flex align-items-center category-item">
                <i className="fa fa-microchip mr-2"></i>
                <span>Hardware: {assessment.Hardware}</span>
              </div>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default SystemAssessmentCard;
